import type { RouteDef } from "../route-config";
import { SessionsRoute } from "./routes/Sessions";

const routes: RouteDef[] = [SessionsRoute];

export default routes;
